import { Controller } from "@hotwired/stimulus"

const KB_BASE = "https://apps.threatops.io/detection_knowledge_base/detectors"

export default class extends Controller {
  get formId() { return this.element.querySelector("form")?.id }
  get schemas() { return this._schemas ||= this.parseData("event-schemas-data") }
  get ruleDetails() { return this._ruleDetails ||= this.parseData("event-schemas-rule-details") }

  search(e) {
    e.preventDefault()
    const input = this.element.querySelector("input[name='search']")
    if (!input) return
    input.value = e.currentTarget.dataset.fieldValue
    input.dispatchEvent(new Event("input", { bubbles: true }))
  }

  applyFilter(e) {
    e.preventDefault()
    const { filterName, filterValue } = e.currentTarget.dataset
    const checkbox = this.element.querySelector(
      `input[type="checkbox"][form="${this.formId}"][name="event_schema_grid[${filterName}][]"][value="${filterValue}"]`
    )
    if (!checkbox || checkbox.checked) return
    checkbox.checked = true
    checkbox.dispatchEvent(new Event("change", { bubbles: true }))
  }

  showSchema(e) {
    e.preventDefault()
    const { schemaTitle, schemaKey } = e.currentTarget.dataset
    const schema = this.schemas[schemaKey]
    if (!schema) return

    const fields = this.ruleDetails[schemaKey] || {}
    const total = Object.values(fields).reduce((s, a) => s + a.length, 0)

    this.populateModal("event-schema-modal", {
      title: schemaTitle,
      badge: total > 0 ? `${total} field references` : "no rules",
    })
    document.getElementById("event-schema-modal-code").textContent = JSON.stringify(schema, null, 2)
    this.openModal("event-schema-modal")
  }

  showRules(e) {
    e.preventDefault()
    const { moduleKey, fieldName, moduleLabel } = e.currentTarget.dataset
    const rules = this.ruleDetails[moduleKey]?.[fieldName] || []

    this.populateModal("event-rules-modal", {
      title: fieldName,
      badge: `${moduleLabel} — ${rules.length} rules`,
      desc: `Sigma rules that reference the ${fieldName} field in their detection logic.`,
    })

    const tbody = document.getElementById("event-rules-modal-body")
    // Escape rule properties: esc() for text, encodeURIComponent() for URLs
    if (tbody) {
      tbody.innerHTML = rules.map(rule => `
        <tr>
          <td class="py-2 px-3 text-sm text-semantics-text-primary dark:text-semantics-text-primary-dark">${this.esc(rule.title)}</td>
          <td class="py-2 px-3 text-right whitespace-nowrap">
            <a href="${KB_BASE}/${encodeURIComponent(rule.id)}" target="_blank" rel="noopener noreferrer"
               class="inline-flex items-center gap-1 text-xs text-semantics-text-hyperlink dark:text-semantics-text-hyperlink-dark hover:underline">
              View &rarr;
            </a>
          </td>
        </tr>`).join("")
    }

    this.openModal("event-rules-modal")
  }

  parseData(id) { return JSON.parse(document.getElementById(id)?.textContent || "{}") }
  openModal(id) { document.dispatchEvent(new CustomEvent("ui:dialog:open", { detail: { id } })) }
  esc(str) { const d = document.createElement("div"); d.textContent = str; return d.innerHTML }

  populateModal(id, { title, badge, desc }) {
    const modal = document.getElementById(id)
    const h3 = modal?.querySelector("h3")
    if (h3) h3.textContent = title
    const badgeEl = document.getElementById(`${id}-badge`)
    if (badgeEl) badgeEl.textContent = badge || ""
    const descEl = document.getElementById(`${id}-desc`)
    if (descEl) descEl.textContent = desc || ""
  }
}
